import { render, staticRenderFns } from "./SolutionsTable.vue?vue&type=template&id=47b18018&scoped=true&"
import script from "./SolutionsTable.vue?vue&type=script&lang=js&"
export * from "./SolutionsTable.vue?vue&type=script&lang=js&"
import style0 from "./SolutionsTable.vue?vue&type=style&index=0&id=47b18018&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b18018",
  null
  
)

export default component.exports